import React from 'react';
import PropTypes from 'prop-types';

import { Polygon } from 'react-google-maps';

// Render a Polygon geojson feature as a Polygon component
const GeojsonFeature = ({ feature, ...otherProps }) => {
  return <Polygon paths={getPaths(feature)} {...otherProps} />;
};
GeojsonFeature.propTypes = {
  feature: PropTypes.object,
};

export const getPaths = feature =>
  feature.geometry.coordinates.map(ring =>
    ring.slice(0, -1).map(([lng, lat]) => ({ lng, lat }))
  );

export default GeojsonFeature;



// WEBPACK FOOTER //
// ./src/common/components/MapComponent/GeojsonFeature.js